<template>
  <div>
    <BlBackdrop
      title="Add new client"
      description="Fill in the datas to create a new client."
      label="Add new client"
      :disabled="isDisabledSubmit"
      :submitLoading="submitLoading"
      @backdrop-close="$emit('close-modal')"
      @backdrop-action="onCreate"
    >
      <div
        :style="{ maxHeight: 'calc(100vh - 16rem)' }"
        class="overflow-y-auto lg:w-160"
      >
        <div
          class="bl-backdrop-form-container px-4 lg:px-8 pb-8 flex flex-col gap-4"
        >
          <BlInputText :input="nameInput" @changed="inputHandler" />
          <div class="w-full flex items-center gap-6">
            <BlInputDate :input="birthdayInput" @changed="inputHandler" />
            <BlInputText :input="emailInput" @changed="inputHandler" />
          </div>
          <BlInputText :input="noteInput" @changed="inputHandler" />
          <BlSearchBox
            v-if="enableBranch"
            type="branch"
            label="Branch tags"
            placeholder="Type tag"
            v-model="branchIds"
            :options="branchOptions"
            @change="branchIds = $event"
          />
          <BlSearchBox
            type="tag"
            label="Client tags"
            placeholder="Type tags"
            v-model="labelIds"
            :options="labels.map(i => ({ value: i.id, label: i.name }))"
            drop="up"
            @change="labelIds = $event"
          />
          <BlSearchBox
            type="user"
            label="Assign to"
            placeholder="Type therapist's name"
            v-model="userIds"
            :options="users.map(i => ({ value: i.id, label: i.name }))"
            drop="up"
            @change="userIds = $event"
            footer
          >
            <div class="flex gap-2 p-2 bg-cornflower-200 rounded-b">
              <BlIcon icon="info" color="cornflower-8" class="w-4 -mt-0.5" />
              <BlTextBody2
                text="Only administrators and designated therapists will have access to view the client."
                class="text-cornflower-800 flex-wrap"
              />
            </div>
          </BlSearchBox>
        </div>
      </div>
    </BlBackdrop>

    <BlBackdrop
      v-if="accessNoticeOpened"
      title="Access notice: limited client view"
      description="Your account is restricted to viewing only clients assigned to you. Since you've opted out of being assigned to this client, you won't be able to access their information after creating their profile. To retain access, please assign yourself in the 'Assign to' input field before finalizing."
      label="Confirm and create"
      @backdrop-close="accessNoticeOpened = false"
      @backdrop-action="onCompleteCreating"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BlBackdrop from "../../BlBackdrop.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputText from "../../BlInputText.vue";
import BlInputDate from "../../BlInputDate.vue";
import BlSearchBox from "../../BlSearchBox.vue";

export default {
  name: "NewClientModal",
  components: {
    BlBackdrop,
    BlTextBody2,
    BlIcon,
    BlInputText,
    BlInputDate,
    BlSearchBox
  },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Name",
        asterisk: true,
        placeholder: "Type your client's name",
        model: ""
      },
      birthdayInput: {
        label: "Birthday",
        asterisk: true,
        model: ""
      },
      emailInput: {
        label: "Email",
        inputType: "email",
        placeholder: "Type your client's email",
        model: ""
      },
      noteInput: {
        label: "Note",
        placeholder: "Client's note",
        textarea: true,
        model: ""
      },
      labelIds: [],
      userIds: [],
      branchIds: [],
      accessNoticeOpened: false
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentCenter",
      "labels",
      "users",
      "branches"
    ]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    branchOptions() {
      return this.branches.map(i => ({
        value: i.id,
        label: i.name,
        color: i.color,
        backgroundColor: i.background_color
      }));
    },
    isDisabledSubmit() {
      if (!this.nameInput.model || !this.birthdayInput.model) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.getUsers({ params: "?sort=name_asc&status=active" });
  },
  mounted() {
    this.nameInput.model = "";
    this.birthdayInput.model = "";
    this.emailInput.model = "";
    this.noteInput.model = "";
    this.labelIds = [];
    this.userIds = [];
    this.branchIds = [];

    if (this.currentUser.restriction_type === "assigned_clients") {
      this.userIds = [this.currentUser.id];
    }
  },
  methods: {
    ...mapActions(["getUsers", "getLabels", "getBranches", "createClient"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onCreate() {
      if (this.currentUser.restriction_type === "assigned_clients") {
        const listed = this.userIds.includes(this.currentUser.id);
        if (!listed) {
          this.accessNoticeOpened = true;
          return;
        }
      }
      this.onCompleteCreating();
    },
    onCompleteCreating() {
      this.accessNoticeOpened = false;
      const data = {
        client: {
          name: this.nameInput.model,
          birthday: this.birthdayInput.model,
          email: this.emailInput.model,
          note: this.noteInput.model,
          user_ids: this.userIds,
          branch_ids: this.branchIds
        },
        label_ids: this.labelIds,
        not_added: false
      };

      if (this.currentUser.restriction_type === "assigned_clients") {
        const listed = this.userIds.includes(this.currentUser.id);
        if (!listed) {
          data.not_added = true;
        }
      }
      this.submitLoading = true;
      this.createClient(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.$emit("close-modal");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/client/NewClientModal.vue